// extracted by mini-css-extract-plugin
export default {"app":"Invite_app__McmIs","info":"Invite_info__hBJv6","user":"Invite_user__cbcB+","item":"Invite_item__6Q-pW","btn":"Invite_btn__nssoa"};